import React from 'react';
import ClinicAppointmentIcon from '../../images/new-home-card-images/ClinicAppointment.svg';
import HospitalizationIcon from '../../images/new-home-card-images/Hospitalization.svg';
import OpdClaimIcon from '../../images/new-home-card-images/OpdClaim.svg';
import HraIcon from '../../images/new-home-card-images/Hra.svg';
import LabTestsIcon from '../../images/new-home-card-images/LabTests.svg';
import MedicineDeliveryIcon from '../../images/new-home-card-images/MedicineDelivery.svg';
import OnlineConsultationsIcon from '../../images/new-home-card-images/OnlineConsultations.svg';
import ReimbursementIcon from '../../images/new-home-card-images/Reimbursement.svg';
import EnrollmentIcon from '../../images/new-home-card-images/EnrollmentIcon.svg';
import CubesIcon from '../../images/new-home-card-images/Cubes.svg';
import vaccineIcon from '../../images/vaccination/Icon_syringe.svg';
import CashlessDental from '../../images/new-home-card-images/cashless-dental.svg';
import HospitalNetworkIcon from '../../images/new-home-card-images/HospitalNetwork.svg';
import CashlessVision from '../../images/new-home-card-images/CashlessVisionIcon.svg';
import styled from 'styled-components';

const OuterContainer = styled.div`
  position: relative;
  width: calc(100% - 15px);
  background: radial-gradient(
    122.85% 53.75% at 50% 50%,
    #ffffff 0%,
    #f0edfa 100%
  );
  border: 1px solid #dcdae6;
  border-radius: 12px;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 160px;
  flex-direction: column;
  z-index: 10;
  cursor: pointer;
  width: 100%;
  min-width: 157px;
  aspect-ratio: 1;
`;

const Title = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
`;

const Offer = styled.div`
  background: #1eb865;
  color: #ffffff;
  border-radius: 0px 0px 12px 12px;
  padding: 1px 8px 1px 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  position: absolute;
  top: 0px;
  display: flex;
`;

const getImageFromIconType = (key) => {
  switch (key) {
    case 'offline-consults':
      return ClinicAppointmentIcon;
    case 'hospitalisation':
      return HospitalizationIcon;
    case 'pb-opd-reimbursement':
      return OpdClaimIcon;
    case 'hra-card':
      return HraIcon;
    case 'diagnostics':
      return LabTestsIcon;
    case 'pharmacy':
      return MedicineDeliveryIcon;
    case 'online-consults':
      return OnlineConsultationsIcon;
    case 'reimbursement':
      return ReimbursementIcon;
    case 'enrollment':
      return EnrollmentIcon;
    case 'cashless-vaccination':
      return vaccineIcon;
    case 'cashless-dental':
      return CashlessDental;
    case 'cashless-vision':
      return CashlessVision;
    case 'web':
    case 'network-hospital-list':
      return HospitalNetworkIcon;
    default:
      return null;
  }
};

export default function NewHomeActionCard({ iconType, title, offer, onTap }) {
  return (
    <OuterContainer onClick={onTap}>
      <div className="flex items-center justify-center pr-4px">
        {offer && <Offer>{offer}</Offer>}
      </div>
      <div className="flex flex-col items-center">
        <img
          src={getImageFromIconType(iconType)}
          width={'60px'}
          height={'60px'}
          style={offer ? { marginTop: '21px' } : { marginTop: '0px' }}
        />
        <Title className="text-center mt-8px">{title}</Title>
      </div>

      <img
        src={CubesIcon}
        className="absolute"
        style={{ bottom: 0, right: 0, zIndex: '0' }}
      />
    </OuterContainer>
  );
}
